// @flow
import { httpPost, httpPut } from 'lib/http'

export const createLineItem = (number: number, subnumber: number, params: Object) => {
  const url = `/admin/accounts/${number}/subaccounts/${subnumber}/line-items`
  return () => httpPost(url, params)
}

export const updateLineItem = (number, subnumber, lineItemId, params: Object) => {
  const url = `/admin/accounts/${number}/subaccounts/${subnumber}/line-items/${lineItemId}`
  return () => httpPut(url, params)
}
export const createSubaccount = (accountNumber: string, params: Object) => {
  const url = `/admin/accounts/${accountNumber}/subaccounts`
  return () => httpPost(url, params)
}
